import { useArticleSearchContext } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/ArticleSearchProvider';
import { useGetArticle } from '@web/newsfeed/hooks/useGetArticle';
import { useParsedContent } from '@web/common/hooks/useParsedContent';
import { useNavigation } from '@web/navigation/NavigationProvider';

export const useArticleSearchDetails = () => {
  const { page, articleId, searchPageId, searchQuery } = useArticleSearchContext();
  const { data: article } = useGetArticle(page.id, articleId);
  const parsedContent = useParsedContent(article?.content || '', null);
  const { navigate } = useNavigation();

  const backToSearch = () => {
    navigate('newsfeed.view.search', {
      pageId: searchPageId,
      query: searchQuery,
      articleId: null,
    });
  };

  return { article, parsedContent, backToSearch };
};
